/**
 * Contains the html input names. These must match with backend in order to map them correctly.
 */
export class CBConstants {
    public static readonly ContactFormPrefix = "__c_";
    public static readonly SelectedContactPerson = CBConstants.ContactFormPrefix + "selectedContact";
    public static readonly OrgName = CBConstants.ContactFormPrefix +  "orgName";
    public static readonly OrgNumber = CBConstants.ContactFormPrefix +  "orgNr";
    public static readonly UtdelningsAdress = CBConstants.ContactFormPrefix +  "utdelningsadress";
    public static readonly PostNr = CBConstants.ContactFormPrefix +  "postNr";
    public static readonly Postort = CBConstants.ContactFormPrefix +  "postort";
    public static readonly OrgEpost = CBConstants.ContactFormPrefix +  "orgEpost";
    public static readonly OrgWeb = CBConstants.ContactFormPrefix +  "orgWeb";
    public static readonly ContactName = CBConstants.ContactFormPrefix +  "cntName";
    public static readonly ContactLastName = CBConstants.ContactFormPrefix +  "cntLastName";
    public static readonly ContactTitle = CBConstants.ContactFormPrefix +  "cntTitle";
    public static readonly ContactEpost = CBConstants.ContactFormPrefix +  "cntEpost";
    public static readonly ContactTel = CBConstants.ContactFormPrefix +  "cntTel";
    public static readonly AccountType = CBConstants.ContactFormPrefix +  "accType";
    public static readonly AccountNumber = CBConstants.ContactFormPrefix +  "accNr";
    public static readonly Plusgiro = "2";
    public static readonly Bankgiro = "1";
}